<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Vue from 'vue'
import Store from '@/store'
import TransitionWrapper from '@/layout/wrappers/transition-wrapper'

export default {

  name: 'TheContent',

  components: {
    TransitionWrapper
  },

  computed: {
    test(){
      return this.$store.getters.loaderText[0].value;
    },
    isLoading () {
      return this.$store.getters.isLoading
    },
    pageMeta() {
      if(this.$route.name === 'home') return this.$store.getters.pages.filter((item, index) => item.url === '/main')[0];

      return this.$store.getters.pages.filter((item, index) => item.url === '/'+this.$route.name)[0];
    }
  },

  watch:{
    'title': 'setTitle'
  },

  beforeRouteEnter: async (to, from, next) => {


    const lang = to.name === 'home' && !to.params.lang ? 'ua' : to.params.lang;

    Store.commit('setLanguage', lang);

    if (!Vue.i18n.localeExists(lang)) await Store.dispatch('fetchMeta', lang);



    next()
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next()
      return
    }

    Store.commit('startLoading', true)

    const lang = to.name === 'home' && !to.params.lang ? 'ua' : to.params.lang

    Store.commit('setLanguage', lang)

    await Store.dispatch('fetchMeta', lang)

    next()
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.content-container
  transition-wrapper(:appear="true" mode="out-in")
    router-view.router-view(
      v-if="!isLoading"
      :key="$route.path")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>



</style>



// WEBPACK FOOTER //
// the-content.vue?e79ad3e8